












































































































import Vue from 'vue'
import {
  Component, Prop,
} from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import ProductTemplateRule from '@/domain/product-template/entity/product-template-rule.entity';
import Rule from '@/domain/rule/entity/rule.entity';
import ContractItemRuleContent from '../contract/manage-calculation/contract-info-content.component.vue';
import CalculationEditionRules from '../contract/manage-calculation/manage-calculation-edition.component.vue';
import CalculationEditionParameters from '../contract/manage-calculation/manage-calculation-parameters.component.vue';

@Component({
  components: {
    MainButton,
    ModalWarning,
    ContractItemRuleContent,
    CalculationEditionRules,
    CalculationEditionParameters,
  },
})
export default class ProductTemplateCalculationModal extends Vue {
  @Prop({
    required: true,
  })
  private value!: boolean;

  @Prop() productTemplateRule!: ProductTemplateRule;

  @Prop() isAdministratorOrSupervisor!: boolean;

  @Prop() profile!: string;

  @Prop() editModeValue!: boolean;

  @Prop() restrictRulesProfile!: Rule;

  @Prop() loading!: boolean;

  rulesKey: number = 0;

  parametersKey: number = 10;

  warningModal: boolean = false;

  ref: any = this.$refs;

  warningMessage = 'Deseja realmente prosseguir? Ao clicar no botão Sim, as alterações serão imediatamente descartadas.';

  cancel(): void {
    this.$emit('cancel');
    this.rerenderComponents();
  }

  private checkESC(evt: KeyboardEvent) {
    if (evt.key === 'Esc') {
      this.$emit('cancel');
    }
  }

  validate() {
    const editionValid = this.ref.editionForm.$refs.form.validate();
    const parametersValid = this.ref.parametersForm.$refs.form.validate();
    if (editionValid && parametersValid) {
      this.persistProductTemplateRules();
    }
  }

  persistProductTemplateRules() {
    this.$emit('persist', this.productTemplateRule);
    this.rerenderComponents();
  }

  handleEditModeValue() {
    this.$emit('editMode');
  }

  confirmWarning() {
    this.warningModal = false;
    this.$emit('cancelEdit');
    this.rerenderComponents();
  }

  cancelWarning() {
    this.warningModal = false;
  }

  rerenderComponents() {
    this.rulesKey += 1;
    this.parametersKey += 1;
  }
}
